import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import Icon from "src/components/Icon"
import { media } from "src/styles/breakpoints"

export default ({ to, className, onClick, label, variant = "default" }) => {
  return (
    <ButtonLink
      to={to || "#"}
      className={`${className} -${variant}`}
      onClick={onClick}
      target={to && to.startsWith("http") ? "_blank" : undefined}
      rel={to && to.startsWith("http") ? "noopener noreferrer" : undefined}
    >
      <ButtonText>
        <span>{label.slice(0, 2)}</span>
        <span>{label.slice(2)}</span>
      </ButtonText>
      <ButtonIcon name="arrow-up-right" />
    </ButtonLink>
  )
}

const ButtonLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 12px 16px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  color: #000;
  header:not(.-dark) &.-white {
    border: 1px solid #fff;
    color: #fff;
    &:hover {
      border-color: rgba(255, 255, 255, 0.8);
    }
  }
  &.-white {
    margin-top: 6px;
    padding: 4px 4px 4px 8px;

    ${media.tablet} {
      margin-top: 0;
      padding: 12px 16px;
    }
  }
  font-weight: 600;
  font-size: 14px;
  line-height: 1.079;
  letter-spacing: -0.14px;
  transition: 0.1s;

  width: 100%;
  &:hover {
    border-color: rgba(0, 0, 0, 0.8);
  }
`

const ButtonText = styled.span`
  white-space: nowrap;
  .-white & {
    & > span {
      text-transform: uppercase;
    }
    & > span:not(:first-child) {
      display: none;
    }
    ${media.tablet} {
      & > span:not(:first-child) {
        display: inline;
      }
      & > span {
        text-transform: none;
      }
    }
  }
`

const ButtonIcon = styled(Icon)`
  width: 19.714px;
  height: 19.714px;
  flex-shrink: 0;
`
